<div class="panel">
  <mat-button-toggle-group
    class="sub-tab-toggle"
    [value]="activeSubTab"
    (change)="onSubTabChanged($event.value)"
    aria-label="Output formulas sub-tab"
  >
    <mat-button-toggle value="range">
      <mat-icon>format_list_numbered</mat-icon>
      Range
      <span class="sub-tab-count">· {{ rangeFormulas.length }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="ev">
      <mat-icon>tune</mat-icon>
      EV
      <span class="sub-tab-count">· {{ evFormulas.length }}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div class="sub-tab-header">
    @if (canWrite) {
      <button
        mat-icon-button
        color="buttonSuccess"
        [matTooltip]="activeSubTab === 'range' ? 'Create new Range formula' : 'Create new EV formula'"
        aria-label="Create output formula"
        (click)="activeSubTab === 'range' ? onCreateRange() : onCreateEv()"
      >
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>

  @if (loaded) {
    @if (visibleFormulas.length === 0) {
      <div class="empty-state">
        No {{ activeSubTab === 'range' ? 'Range' : 'EV' }} formulas yet. Click the + button to
        add one.
      </div>
    } @else {
      <div class="spec-list">
        @for (row of visibleFormulas; track row.id) {
          <div class="spec-list-item">
            <div class="spec-info">
              <div class="spec-name-row">
                <span class="spec-name">{{ row.name }}</span>
                <span class="range-meta">
                  <mat-icon class="mat-icon-inline">{{ metaBadge(row).icon }}</mat-icon>
                  {{ metaBadge(row).label }}
                </span>
              </div>
              <div class="spec-summary-row">
                @if (refs(row); as r) {
                  @if (r.stillsSpecName; as name) {
                    <span class="spec-kv">
                      <span class="k">
                        <mat-icon class="mat-icon-inline">image</mat-icon>
                        Stills spec
                      </span>
                      <span class="v">{{ name }}</span>
                    </span>
                  }
                  @if (r.stillsConventionName; as name) {
                    <span class="spec-kv">
                      <span class="k">
                        <mat-icon class="mat-icon-inline">image</mat-icon>
                        Stills convention
                      </span>
                      <span class="v">{{ name }}</span>
                    </span>
                  }
                  @if (r.videosSpecName; as name) {
                    <span class="spec-kv">
                      <span class="k">
                        <mat-icon class="mat-icon-inline">movie</mat-icon>
                        Videos spec
                      </span>
                      <span class="v">{{ name }}</span>
                    </span>
                  }
                  @if (r.videosConventionName; as name) {
                    <span class="spec-kv">
                      <span class="k">
                        <mat-icon class="mat-icon-inline">movie</mat-icon>
                        Videos convention
                      </span>
                      <span class="v">{{ name }}</span>
                    </span>
                  }
                  @if (r.evConventionSummary; as summary) {
                    <span class="spec-kv">
                      <span class="k">EV conventions</span>
                      <span class="v">{{ summary }}</span>
                    </span>
                  }
                }
              </div>
            </div>
            <div class="row-actions">
              @if (canAudit) {
                <button
                  mat-icon-button
                  color="primary"
                  matTooltip="View change history"
                  aria-label="View change history"
                  (click)="onViewFormulaHistory(row)"
                >
                  <mat-icon>history</mat-icon>
                </button>
              }
              @if (canWrite) {
                <button
                  mat-icon-button
                  color="buttonSuccess"
                  matTooltip="Update"
                  aria-label="Update output formula"
                  (click)="onUpdateFormula(row)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Delete"
                  aria-label="Delete output formula"
                  (click)="onDeleteFormula(row)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
